'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoOutlet = function IoOutlet(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm26.4 2.5c4.8 0 8.6 4 8.6 8.8v17.4c0 4.8-3.8 8.8-8.6 8.8h-17.8c-4.8 0-8.6-4-8.6-8.8v-17.4c0-4.8 3.8-8.8 8.6-8.8h17.8z m-15.2 17.1v-8c0-0.8-0.7-1.6-1.6-1.6h-1.8c-0.9 0-1.5 0.7-1.6 1.6v8.1c0 0.8 0.7 1.5 1.6 1.5h1.8c0.9 0 1.6-0.7 1.6-1.5v-0.1z m9.5 11.3v-2.2c0-1.8-1.4-3.3-3.2-3.3s-3.2 1.5-3.2 3.3v2.2c0 0.9 0.7 1.6 1.6 1.6h3.2c0.9 0 1.6-0.5 1.6-1.4v-0.2z m8.1-11.3v-8c0-0.8-0.8-1.6-1.6-1.6h-1.9c-0.8 0-1.5 0.7-1.6 1.6v8.1c0 0.8 0.8 1.5 1.6 1.5h1.9c0.8 0 1.5-0.7 1.5-1.5v-0.1z' })
        )
    );
};

exports.default = IoOutlet;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/outlet.js
// module id = 2368
// module chunks = 0